module.exports = __webpack_public_path__ + "static/media/de.85f98c37.svg";